export default {
  scenes: {
    flightForAnswers: {
      beats: {
        unfinishedStory: {
          events: [
            {
              type: 'showLocation',
              locationId: 'airplane'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'thinking',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: 'I don\'t know what I\'m expecting—but I can\'t let things end in silence. Not like this.',
              choices: [
                {
                  text: 'She Wants Closure',
                  next: {
                    scene: 'flightForAnswers',
                    beat: 'wantsClosure'
                  }
                },
                {
                  text: 'She Wants Him Back',
                  next: {
                    scene: 'flightForAnswers',
                    beat: 'wantsHimBack'
                  }
                }
              ]
            }
          ]
        },
        wantsClosure: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'I just need to know why he left. Then I can move on.'
            },
            {
              type: 'showNarration',
              text: 'She grips her seat, mentally preparing for the worst.'
            },
            {
              type: 'showEffect',
              effect: 'screenShake',
              intensity: 5,
              duration: 0.5,
              waitUntilFinish: true
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: 'Maybe this was a mistake.'
            }
          ],
          next: {
            scene: 'faceToFace',
            beat: 'meetingAlmostDoesntHappen'
          }
        },
        wantsHimBack: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: 'What if there\'s still a chance?'
            },
            {
              type: 'showNarration',
              text: 'Hope lingers, even when she tries to push it away.'
            },
            {
              type: 'showEffect',
              effect: 'screenShake',
              intensity: 5,
              duration: 0.5,
              waitUntilFinish: true
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: 'Maybe this was a mistake.'
            }
          ],
          next: {
            scene: 'faceToFace',
            beat: 'meetingAlmostDoesntHappen'
          }
        }
      }
    },
    faceToFace: {
      beats: {
        meetingAlmostDoesntHappen: {
          events: [
            {
              type: 'showLocation',
              locationId: 'cityStreet'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showNarration',
              text: 'Reina sends a message. Hours pass. No response. Just as she\'s about to give up, her phone vibrates.'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'neutral',
              text: 'Meet me at the riverbank. 8 PM.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'How should I react?',
              choices: [
                {
                  text: 'Relief',
                  next: {
                    scene: 'faceToFace',
                    beat: 'relief'
                  }
                },
                {
                  text: 'Frustration',
                  next: {
                    scene: 'faceToFace',
                    beat: 'frustration'
                  }
                }
              ]
            }
          ]
        },
        relief: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'At least he\'s willing to talk.'
            },
            {
              type: 'showNarration',
              text: 'She doesn\'t know what to expect, but it\'s something.'
            }
          ],
          next: {
            scene: 'faceToFace',
            beat: 'seeingHimAgain'
          }
        },
        frustration: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'angry',
              text: 'After all this, that\'s all he says?'
            },
            {
              type: 'showNarration',
              text: 'She almost doesn\'t go. Almost.'
            }
          ],
          next: {
            scene: 'faceToFace',
            beat: 'seeingHimAgain'
          }
        },
        seeingHimAgain: {
          events: [
            {
              type: 'showLocation',
              locationId: 'riverbank'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showNarration',
              text: 'The moment she sees him, everything floods back. He looks the same—but something is different. There\'s tension in his shoulders, guardedness in his eyes.'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'neutral',
              text: 'You actually came.'
            }
          ],
          next: {
            scene: 'hardConversation',
            beat: 'truthComesOut'
          }
        }
      }
    },
    hardConversation: {
      beats: {
        truthComesOut: {
          events: [
            {
              type: 'showLocation',
              locationId: 'riverbank'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showNarration',
              text: 'They sit by the river, the same way they used to. But there\'s no laughter now, no easy conversation. Just the weight of everything unsaid.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'How should I begin?',
              choices: [
                {
                  text: 'Direct Confrontation',
                  next: {
                    scene: 'hardConversation',
                    beat: 'directConfrontation'
                  }
                },
                {
                  text: 'Gentler Approach',
                  next: {
                    scene: 'hardConversation',
                    beat: 'gentlerApproach'
                  }
                }
              ]
            }
          ]
        },
        directConfrontation: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'angry',
              text: 'Why did you shut me out? I deserve an answer.'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'sad',
              text: 'You wouldn\'t have understood.'
            }
          ],
          next: {
            scene: 'hardConversation',
            beat: 'realReason'
          }
        },
        gentlerApproach: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: 'I just… need to know why. Please.'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'sad',
              text: 'It wasn\'t supposed to end like this.'
            }
          ],
          next: {
            scene: 'hardConversation',
            beat: 'realReason'
          }
        },
        realReason: {
          events: [
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'sad',
              text: 'I didn\'t want you to wait for something I wasn\'t sure I could give.'
            }
          ],
          next: {
            scene: 'choiceThatChangesEverything',
            beat: 'canLoveSurviveThis'
          }
        }
      }
    },
    choiceThatChangesEverything: {
      beats: {
        canLoveSurviveThis: {
          events: [
            {
              type: 'showLocation',
              locationId: 'riverbank'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: 'What should I do?',
              choices: [
                {
                  text: 'Forgive Him and Try Again',
                  next: {
                    scene: 'choiceThatChangesEverything',
                    beat: 'newBeginning'
                  }
                },
                {
                  text: 'Let Go and Walk Away',
                  next: {
                    scene: 'choiceThatChangesEverything',
                    beat: 'finalGoodbye'
                  }
                }
              ]
            }
          ]
        },
        newBeginning: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: 'We can\'t undo the past. But maybe we can start again.'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'happy',
              text: 'If you\'re willing to try… I won\'t run this time.'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'happy',
              text: 'We\'ll do this right this time.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: 'Yeah. We will.'
            },
            {
              type: 'showNarration',
              text: 'THE END.'
            }
          ],
          goToGameOver: true
        },
        finalGoodbye: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: 'I needed to hear this. But I think… we were only meant to be for a little while.'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'sad',
              text: 'I\'ll regret losing you.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: 'Then why did you?'
            },
            {
              type: 'showNarration',
              text: 'She leaves, knowing she\'ll be okay. He watches her go, knowing he lost something he can\'t get back.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'Goodbye, Eric.'
            },
            {
              type: 'showNarration',
              text: 'THE END.'
            }
          ],
          goToGameOver: true
        }
      }
    }
  }
}
